import axiosInstance from '@/utils/api.js'

var state = {
  httpServers: []
}

var getters = {
  HTTP_SERVERS: (state) => {
    return state.httpServers
  }
}

var mutations = {
  SET_HTTP_SERVERS: (state, payload) => {
    state.httpServers = payload
  }
}

var actions = {
  GET_HTTP_SERVERS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/http_servers')
    if (result.status === 200) {
      context.commit('SET_HTTP_SERVERS', result.data)
    }
  },
  CREATE_HTTP_SERVERS: (context, payload) => {
    return axiosInstance.post('/settings/http_servers', payload)
  },
  UPDATE_HTTP_SERVERS: (context, payload) => {
    return axiosInstance.put('/settings/http_servers', payload)
  },
  DELETE_HTTP_SERVERS: (context, payload) => {
    return axiosInstance.delete('/settings/http_servers?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/httpServers.js